import { useContext } from 'react';
import { AriaConversationContext } from '@/components/ai/AriaConversationContext';

/**
 * Access the shared ARIA conversation store (messages, conversationId, pending
 * actions, streaming state + the send/confirm/reject/load actions). Must be used
 * under <AriaConversationProvider> (mounted in Layout).
 */
export function useAriaConversation() {
  const ctx = useContext(AriaConversationContext);
  if (!ctx) {
    throw new Error('useAriaConversation must be used within <AriaConversationProvider>');
  }
  return ctx;
}

export default useAriaConversation;
